/**
 * Whether a notification's deep_link points at the view the user is already on.
 *
 * Requires matching pathname + the same `flow` query param (all generation
 * deep links are flow-scoped). Path-only links without `flow` never match —
 * that would suppress every module notification while browsing the list.
 */
export function notificationMatchesActiveContext(
  deepLink: string | undefined | null,
  pathname: string,
  search: string,
): boolean {
  if (!deepLink || !deepLink.startsWith('/')) return false

  let link: URL
  try {
    link = new URL(deepLink, 'http://local.invalid')
  } catch {
    return false
  }

  if (normalizePath(link.pathname) !== normalizePath(pathname)) return false

  const flow = link.searchParams.get('flow')
  if (flow == null || flow === '') return false

  return new URLSearchParams(search).get('flow') === flow
}

function normalizePath(path: string): string {
  if (path.length > 1 && path.endsWith('/')) return path.slice(0, -1)
  return path
}
